<template>
  <div>
    <span>{{ dictName }}</span>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'dictSpan',
    props: {
      value: {
        // 必须要使用value ==父组件v-model值
        default: '',
      },
      dictType: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState({
        dictName(state) {
          let dictType = this.dictType;
          let name = this.value;
          if (state.dict.dictList.find((it) => it.dictType == dictType)) {
            let dictList = state.dict.dictList.find((it) => it.dictType == dictType).dictList;
            if (dictList.find((it) => it.value == this.value)) {
              name = dictList.find((it) => it.value == this.value).label;
            }
          }
          return name;
        },
      }),
    },
  };
</script>
